<div class="row company-header-main">
  <div></div>
  <div class="company-header-logo">
    <img class="img-responsive" src="assets/img/login/utender_icon.png" alt="logo" />
  </div>
  <div class="provided-by">
    <span>provided by</span>
    <img class="img-responsive occon-icon" src="assets/img/login/occon_logo.png" alt="occon logo"/>
  </div>
  <div></div>
</div>

<div class="company-header-sub">
  <div class="text-left">
    {{ message }}
  </div>
  <div class="text-right">
    <ul class="nav navbar-top-links navbar-right language-select">
      <li>
        <a data-toggle="dropdown" class="count-info" href="#">
          {{ 'GENERAL.LANGUAGE' | translate:locale.language }}
        </a>
        <ul class="dropdown-menu animated fadeInRight m-t-xs">
          <li><a (click)="changeLanguage('en')">English</a></li>
          <li><a (click)="changeLanguage('de')">Deutsch</a></li>
          <li><a (click)="changeLanguage('es')">Espa&#xf1;ol</a></li>
          <li><a (click)="changeLanguage('pt')">Português</a></li>
          <!--<li><a (click)="changeLanguage('fr')">Fran&#xe7;ais</a></li>

          <li><a (click)="changeLanguage('jp')">日本の</a></li>
          <li><a (click)="changeLanguage('ko')">한국의</a></li>-->
        </ul>
      </li>
    </ul>
  </div>
</div>
